import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {get} from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {Icon} from '@material-ui/core';

const ERROR_LIST = [
  'sdcarddoorclosed',
  'offline',
  'sdcardunplugged',
  'sdcardunmounted',
  'hasnoimage',
  'dimensionunmatched',
  'dimensionunvailable',
  'sdcardhealthunchecked',
  'dvrnotrecording'
];

const DIMENSION_ERROR_LIST = [
  'dimensionunmatched',
  'dimensionunvailable'
]

export default class DVRErrorsPanel extends React.PureComponent {

  static propTypes = {
    substatus: PropTypes.object,
    alerts: PropTypes.array,
    pairingMethod: PropTypes.string
  }

  shouldShowError(alertType) {
    return ERROR_LIST.includes(alertType);
  }

  shouldCheckError(alertType) {
    return ['dimensionunmatched', 'dimensionunvailable'].includes(alertType);
  }

  getErrors() {
    const substatus = get(this.props, 'substatus', {});
    const alerts = get(this.props, 'alerts', []);
    const pairingMethod = get(this.props, 'pairingMethod', 'dsn');

    if (alerts.length <= 0) {
      return [];
    }

    return alerts.filter(alert => {
      if (!this.shouldShowError(alert.type)) {
        return false;
      }

      if (this.shouldCheckError(alert.type)) {
        return get(substatus, alert.type, false);
      }

      return true;
    }).map(alert => {
      let alertType = alert.type;
      if (DIMENSION_ERROR_LIST.includes(alert.type)) {
        alertType = `${alert.type}.${pairingMethod}`
      }
      return {
        type: alert.type,
        message: I18n.t(`page.dvrHealth.dvr.error.${alertType}`),
        severity: alert.severity
      };
    });
  }

  render() {
    const errors = this.getErrors();

    if (errors.length <= 0) {
      return null;
    }

    return (
      <div>
        <h4 className="dvrcard__infotitle dvrcard__warningtitle">
          <Icon className="dvrcard__warningtitle-icon">warning</Icon>
          {I18n.t('page.dvrHealth.dvr.problemsFoundTitle')}
        </h4>

        <Table className="dvrcard__table">
          <TableBody>
            {errors.map((error, index) => (
              <TableRow id={`${error.type}DvrError`} key={index}>
                <TableCell>{error.message}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <div id="supportMessage" className="dvrcard__support-link">
          {I18n.t('page.dvrHealth.supportLinkTitle')}
          &nbsp;
          <a
            id="supportLink"
            href="https://sites.google.com/peoplenetonline.com/video-intelligence-resources"
            target="_blank" rel="noopener noreferrer"
          >
            {I18n.t('page.dvrHealth.supportLinkName')}
          </a>
        </div>
      </div>
    );
  }

}
